@if(orderLine){
<button [disabled]="loading" (click)="removeItem(orderLine.id)" pButton pRipple
  class="c-button icon-only table-action-btn p-unset-xxl">
  @if(!loading){
  <img src="./../../../../../assets/images/icons/delete_forever.svg" alt="delete">
  } @else {
  <p-progressSpinner styleClass="c-loader small" strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s">
  </p-progressSpinner>
  }
</button>
}
